import { useMutation } from 'query';
import { mediaDelete } from '../../services';

export const useDeleteMediaMutation = () =>
  useMutation<unknown, { id: string }>({
    async mutationFn({ id }) {
      const response = await mediaDelete({ id });
      return response.data;
    },
  });
